<template>
  <div class="projectArea">
    <div class="projectInnerArea">
      <img :src="img['bg']" class="imageCover op20"/>
      <div class="positionAbsolute center t20 l50 h20 w20">
        <img :src="img['logo']" class="absoluteCenter h100">
      </div>

      <div class="positionAbsolute t40 l5 w100">
        <div class="title" v-html="$t('shs618Title')">
        </div>
      </div>

      <div class="positionAbsolute t50 l5 w100">
        <div class="description" v-html="$t('shs618Description')">
        </div>
      </div>

      <div class="positionAbsolute t75 l5 h20 w20">
        <img :src="img['playVideoIcon']" class="absoluteCenter h100"/>
        <div class="absoluteCenter h100 w100 touch hoverCursorPointer " @mouseup="openVideo()">
        </div>
      </div>


      <div class="positionAbsolute center t78 l78 h45 w45">
        <img :src="img['bird']" class="absoluteCenter h100"/>
      </div>

      
      <transition name="fade">
        <div class="absoluteCenter h100 w100 touch bgBlack" v-show="this.isShowVideo">
          <video ref="video" class="absoluteCenter h100 w100 touch" controls controlsList="nodownload" playsinline>
            <source :src="this.videoSrc" type="video/mp4">
          </video>
          
          <div class="positionAbsolute t3 r3 w10 h10 touch" @mouseup="closeVideo()">
            <img :src="img['closeIcon']" class="absoluteCenter h100" >
          </div>
        </div>
      </transition>

    </div>
    

  </div>
</template>

<script>

import i18n from '@/language';
import { store } from '@/store'

export default {
  name: 'projectShs618',
  data () {
    return {
      language : i18n.locale,

      videoSrc : './static/videos/shs618.mp4',

      img : {
        logo : "static/images/project/shs618/logo.webp",
        bg : "static/images/project/shs618/bg.webp",
        playVideoIcon : "static/images/icon/playVideoBlack.webp",
        closeIcon : "static/images/icon/close.webp",

        bird : "static/images/project/shs618/bird.webp",
      },

      isShowVideo : false,

    }
  },
  mounted(){
    setTimeout(function(){
      store.state.projectLoaded += 1;
    },50)
  },
  created(){
    store.state.projectCount += 1;
  },
  methods:{
    openVideo(){
      this.isShowVideo = true;
      this.$refs.video.play();
    },

    closeVideo(){
      this.isShowVideo = false;
      this.$refs.video.currentTime = 0;
      this.$refs.video.pause();
    },

  },

  computed:{
    checkCurrentLanguage(){return i18n.locale;},
    checkSelectingVideo(){return store.state.selectingVideo},
  },
  watch:{
    checkCurrentLanguage(lang){this.language = lang;},
    checkSelectingVideo(video){
      var vid = document.getElementById("HKRIVideo");
      if(video == "HKRI"){
        this.isShowVideo = true;
        if(store.state.isGAEvent){
          gtag('event', 'playVideo_HKRI', {'event_callback': function() {}});
        }
        vid.play();
      }
      else{
        this.isShowVideo = false;
        
        vid.pause();
      }  
    }
  },
}
</script>

<style  scoped src="@/assets/styles/projectStyle.css">
</style>

<style scoped>

@media (max-aspect-ratio: 4/3) {

}

</style>



// WEBPACK FOOTER //
// src/components/projects/projectShs618.vue